import * as React from "react";
import Collapse from "../../Utilities/Collapse";
export const NavDropDown = (props) => {
    return (React.createElement("ul", { className: "nav nav-sm flex-column", "data-testid": props.testId },
        React.createElement(Collapse, { isOpen: props.isOpen, timeout: 150 }, props.children)));
};
//# sourceMappingURL=NavDropDown.js.map